import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { isPageActive } from '@/lib/is-page-active';
import {
  confirmationHistoryStore,
  confirmationsStore,
  dealStore,
  primaryCustomerStore,
  smsAgentMessageStore,
  userStore,
  vehicleFromIndexerStore,
  vehicleListingStore,
} from '@/models/stores';
import { runInAction } from 'mobx';
import { useEffect } from 'react';

const useMyDealsPageHydrateLocal = () => {
  const isMyDealsPageActive = isPageActive(PAGE_ROUTES.MY_DEALS);
  const shouldRun = isMyDealsPageActive;

  useEffect(() => {
    if (!shouldRun) {
      return;
    }

    const hydrateDeals = async () => {
      // This can be optimized by running this for only the deals above the fold
      // which are the deals with statuses: new, in_progress, awaiting_delivery, delivered
      await Promise.all([
        dealStore.hydrateActiveDeals(),
        primaryCustomerStore.hydrateLocal(),
        vehicleFromIndexerStore.hydrateLocal(),
        vehicleListingStore.hydrateLocal(),
        userStore.hydrateLocal(),
        smsAgentMessageStore.hydrateLocal(),
      ]);

      await Promise.all([
        confirmationsStore.hydrateOnlyForNewDeals(),
        confirmationHistoryStore.hydrateOnlyForNewDeals(),
      ]);
    };

    runInAction(async () => {
      await hydrateDeals();
    });
  }, [shouldRun]);
};

export default useMyDealsPageHydrateLocal;
